<template>
  <div class="validation-management">
    <el-card style="height: 100%">
      <el-table
        :data="tableData"
        border
        style="width: 100%"
        @cell-click="onCellClick"
        @keyup.enter.native="onEnterPress"
        :cell-style="cellStyle"
      >
        <template v-for="column in columns">
          <el-table-column
            v-if="!!column.props.includes('operation')"
            :prop="column.props"
            :label="column.label"
            :width="column.width || ''"
            :key="column.props"
          >
            <template slot-scope="scope">
              {{ scope.row[column.props].deadline}}
              <el-button
                class="month-button"
                type="primary"
                size="mini"
                v-show="!activeInput"
                >月份</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            v-else
            :prop="column.props"
            :label="column.label"
            :width="column.width || ''"
            :key="column.label"
          >
           <template slot-scope="scope">
              {{ scope.row[column.props].pack_option_text}}
            </template>
          </el-table-column>
        </template>
      </el-table>
      <detail-dialog ref="detailDialog" :update-list="getTableColumns"></detail-dialog>
    </el-card>
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from 'vuex'
import DynamicInput from "./components/DynamicInput.vue";
import DetailDialog from "./components/DetailDialog.vue";
import {validationListUrl,updateValidationUrl} from '@/api.js'
export default {
  name: "ValidationManagement",
  components: { DynamicInput, DetailDialog },
  data() {
    return {
      activeInput: null, //当前激活的输入框
      activeCellInfo: null, //当前击中的单元格的信息
      isEntered: true,
      columns:[],//表格列信息
      tableData: [],
    };
  },
  computed: {
      ...mapGetters(['exec',])
  },
  created() {
    this.getTableColumns()
  },
  methods: {
    //获取表格的列信息
    async getTableColumns(){
     let res = await this.$request('get',validationListUrl,{})
     //处理表格数据到需要的格式
     this.tableData=  res.slice(1).map((item)=>{
        let obj ={}
        obj['material'] = item[0]  //包装材料
        item.forEach((op,index)=>{
          if(index>0&&index<item.length){
            obj[`operation${index}`] = op
          }
        })
        return obj
      })

    //生成表格的列信息
    if(this.exec[580]){
      for (const key in this.tableData[0]) {
        if (this.tableData[0][key].handle_option === 4) {
          delete this.tableData[0][key];
        }
      }
    }
    // console.log(this.tableData[0])
    this.columns = Object.keys(this.tableData[0]).map(item=>{
      return {
        props:item,
        label:this.tableData[0][item].handle_option_text
      }
    })
    },

    // 更新有效期
    async updateValidation(){
        let {deadline,pack_option,handle_option}= this.activeCellInfo.row[this.activeCellInfo.column.property]

        return this.$request('post',updateValidationUrl,{
            "deadline":deadline,//有效期
            pack_option,//包装方式值
            handle_option//处理方式值
        })
    },

    // 单元格单击
    onCellClick(row, column, cell, event) {
      // console.log('column',column,event);
      if (!column.property.includes('operation') ||event.target.nodeName === "TD") return; //排除不需要编辑的单元格
      if( !this.isEntered){   //没有保存编辑也不允许创建新的
        return this.$message.error(`请保存后再操作`)
      }
      if (event.target.nodeName !== "DIV") {
        //如果点击的是月份按钮,处理点击按钮
        this.handleMonthButtonClick(row, column);
        return;
      }
      this.isEntered = false;    //开始编辑
      const div = document.createElement("div"); //创建元素用于动态创建的输入框组件的挂载。vue2并不支持文档碎片挂载
      const vm = Vue.extend(DynamicInput); //动态创建输入框组件并挂载
      this.activeInput = new vm({
        propsData: {cell: row[column.property] },
      }).$mount(div);
      cell.appendChild(this.activeInput.$el); //将动态创建的组件插入到单元格中
      cell.querySelector("input").focus(); //将动态创建的输入框聚焦
      this.activeCellInfo = { row, column, cell }; //将当前cell保存，以便后期清除
    },
    async onEnterPress(e) {
      //监听enter事件，发送请求
      try {
        const res = await this.updateValidation()
        if (res) {
          this.$message.success(`更新成功`);
          //请求成功销毁输入框
          this.activeInput &&  this.activeCellInfo.cell.removeChild(this.activeInput.$el);
          this.isEntered = true;
          this.activeInput = null;
          //刷新列表
          this.getTableColumns()
        }
      } catch (err) {
        return;
      }
    },
    //处理月份按钮点击
    handleMonthButtonClick(row, column) {
      this.$refs.detailDialog.open(row, column)
    },
    cellStyle({row, column, rowIndex, columnIndex}) {
      if (column.property.includes('operation')) {
        const data = row[column.property].month_detail.filter(v => v.deadline !== row[column.property].deadline)
        if (data.length > 0) {
          return { color: 'red' }
        }
      }
    }
  },
};
</script>

<style lang="scss" scoped>
.validation-management {
  /deep/ .el-input {
    height: 100% !important;
  }
  /deep/ .el-input__inner {
    position: relative;
    height: 100% !important;
  }
  /deep/.el-input-number__decrease {
    height: 45% !important;
  }
  /deep/.el-input-number__increase {
    height: 45% !important;
  }

  .month-button {
    position: absolute;
    right: 0;
    bottom: 0;
  }
}
</style>